// eslint-disable-next-line no-restricted-imports
import type { AppFlyoutAnchorState } from "@1js/acui-button/lib/Next";

export const useAppPreviewGalleryFlyoutAnchorStyles: (
  state: AppFlyoutAnchorState
) => AppFlyoutAnchorState = (state) => {
  return state;
};
